export default "__VITE_ASSET__B4Lk2IcU__"